'use strict';

import { module } from '../app';

module.service('serverTimeService', [ 'Magview', 'localStorage', function (Magview, localStorage) {
  let service = {
    updateServerTime: function () {
      Magview.getServerTime().then(function (data) {
        let diff = new Date(data.data.now) - new Date();
        localStorage.set('serverDiff', diff);
      }, function () {
        localStorage.set('serverDiff', 0);
      });
    },

    getDiff: function () {
      return parseInt(localStorage.get('serverDiff')) || 0;
    }
  };

  return service;
} ]);



// WEBPACK FOOTER //
// ./src/scripts/services/serverTime.js